export default "__VITE_ASSET__BSq9m$aM__"